





























































import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import PlanEditResultMixin from '@/mixins/plan/edit/PlanEditResultMixin';
import {PlanEditResultConfigItem} from '@/models/PlanEditResultConfigModel';
import PlanEditResultConfigComponentsEnum from '@/enums/PlanEditResultConfigComponentsEnum';
import {mapState} from 'vuex';
import PlanEditModel, {WarehouseDescription} from '@/models/PlanEditModel';
import PlanEditResultModel from '@/models/PlanEditResultModel';
import PlanEditResultConfigTabTypesEnum from '@/enums/PlanEditResultConfigTabTypesEnum';
import PlanEditResultShiftEnum from '@/enums/PlanEditResultShiftEnum';
import CTextField from '@/components/base/textField/CTextField.vue';

@Component({
    components: {CTextField},
    computed: {
        ...mapState('planEdit', ['warehousePlywoodDescriptions', 'warehouseVeneerDescriptions']),
        ...mapState('planEditResult', ['result', 'equipmentTypesFromCatalogue']),
        ...mapState('planEditResultEdit', ['activeTabs']),
    },
})
export default class PlanEditResultEditItem extends Mixins(PlanEditResultMixin) {
    @Prop() data!: PlanEditResultConfigItem;

    public activeTabs!: PlanEditResultConfigTabTypesEnum[];

    private showComponent: boolean = false;
    private name: string = '';
    private settingsDescriptions: any = null;
    private loadingSettingsDescriptions = false;
    private params: any = null;

    public warehousePlywoodDescriptions!: WarehouseDescription[];
    public warehouseVeneerDescriptions!: WarehouseDescription[];
    public equipmentTypesFromCatalogue!: WarehouseDescription[];
    public result!: PlanEditResultModel;

    get component() {
        return this.getComponent(this.localData.componentKey);
    }

    get localData() {
        return this.data;
    }
    set localData(value: any) {
        this.$emit('update:data', value);
    }

    get props() {
        return this.localData.props;
    }
    set props(value: any) {
        this.localData.props = value;
    }

    get isTab() {
        return this.localData.componentKey === PlanEditResultConfigComponentsEnum.Tabs;
    }

    get title() {
        return this.getComponentTitle(this.localData.componentKey);
    }

    get requestParams() {
        return this.localData.requestParams;
    }
    set requestParams(value: any) {
        this.localData.requestParams = value;
    }

    get componentRequestParams() {
        return this.getComponentRequestParams(this.localData.componentKey);
    }

    get textFieldValue() {
        return this.data?.userTitle ? this.data.userTitle : this.title;
    }
    get tabData() {
        return {
            idPlanRes: this.result.Id,
            shiftIndex: this.result.Shifts[0].ShiftIndex,
            idWarehouseVeneer: this.warehouseVeneerDescriptions[0].Id,
            idWarehousePlywood: this.warehousePlywoodDescriptions[0].Id,
            idEquipmentType: this.equipmentTypesFromCatalogue[0].Id,
        };
    }

    get componentApi() {
        return this.getComponentApi(this.localData.componentKey);
    }

    get realSettingsDescriptions() {
        return this.settingsDescriptions
            ? [{Id: null, Name: this.$t('Common.NoChoose')}, ...this.settingsDescriptions]
            : null;
    }

    get isCompressed() {
        return this.localData.isCompressed;
    }

    @Watch('data', {deep: true, immediate: true})
    onDataChange(value: PlanEditResultConfigItem) {
        const requestParams = value.requestParams?.map(param => {
            if (param.value === PlanEditResultShiftEnum.First) {
                return {...param, value: this.result.Shifts[0].ShiftIndex};
            } else if (param.value === PlanEditResultShiftEnum.Last) {
                return {...param, value: this.result.Shifts[this.result.Shifts.length - 1].ShiftIndex};
            } else return param;
        });
        this.params = {
            title: value.userTitle ? value.userTitle : this.title,
            requestParams,
            api: this.componentApi,
        };
    }
    created() {
        this.getTableSettingsDescriptions();
    }
    onNameInput(value: string) {
        this.data.userTitle = value;
    }
    async getTableSettingsDescriptions() {
        if (!this.componentApi) return;
        const componentParams: {[key: string]: number | string} = {};
        let data: any = this.tabData;
        this.requestParams?.forEach((item: {key: string; [key: string]: any}) => {
            componentParams[item.key] = data[item.key];
        });
        this.loadingSettingsDescriptions = true;
        try {
            const {data} = await this.$http.get(`${this.componentApi}/GetConfigAll`, {
                params: {
                    idPlanRes: this.result.Id,
                    ...componentParams,
                },
            });
            this.settingsDescriptions = data;
        } finally {
            this.loadingSettingsDescriptions = false;
        }
    }

    getSelectItems(param: any, index: number) {
        const rp = this.componentRequestParams;
        let activeTabs = this.activeTabs.slice(0, this.data.props?.depth);
        let desciptions = [];
        if (rp) {
            const disabledFromTab = !activeTabs.includes(rp[index].dependencieTab);
            desciptions = rp[index].getDescriptions(disabledFromTab);
        }
        return desciptions;
    }
}
